import { Link } from "@StarberryUtils";
import * as React from "react"
import HTMLReactParser from 'html-react-parser';
import { Container, Row, Col, Button } from "react-bootstrap"
import { useStaticQuery, graphql } from "gatsby";
import ModalTiny from "react-bootstrap/Modal"
import whatsappIcon from "../../images/home/whatsapp-icon.png"
import Dacha from "../../images/dacha.png"
import "../PropertyDetails/ProductInfo/ProductInfo.scss"
import { GetURL } from "../common/site/functions";
import { useLocation } from "@reach/router"
import ContactForm from "../forms/contact-form";
import {
	EmailShareButton,
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton,
	WhatsappShareButton
} from "react-share";

import {
	EmailIcon,
	FacebookIcon,
	LinkedinIcon,
	TwitterIcon,
	WhatsappIcon
} from "react-share";
import { PhoneIconBlue, PhoneIconGrey, EnvelopeIconBlue, EnvelopeIconGrey, WhatsAppIconBlue, WhatsAppIconGreen, CloseIcon } from "../Icons/Icons";

const Sidebar = (props) => {

	const location = useLocation();

	const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    globalModule {
		  Static_Page_Sidebar_Title
	      Static_Page_Sidebar_CTA_Label
	      Static_Page_Sidebar_Content
	      Static_Page_Sidebar_CTA_Link {
	        id
	      }
		  Opening_Hours
	    }
      }
    }
  `);

	const content = data.glstrapi.globalModule

	let url = ''
	if (content.Static_Page_Sidebar_CTA_Link) {
		url = GetURL(content.Static_Page_Sidebar_CTA_Link.id)
	}

	// Share icons
	const shareurl = typeof window !== 'undefined' ? window.location.href : ''
	const [Shareicons, setShareicons] = React.useState(false);
	const [ShareiconsMobile, setShareiconsMobile] = React.useState(false);
	const openShareicons = () => {
		setShareicons(true);
	}

	const closeShareicons = () => {
		setShareicons(false);
	}
	const openShareiconsMobile = () => {
		setShareiconsMobile(true);
	}

	const closeShareiconsMobile = () => {
		setShareiconsMobile(false);
	}
	const trackerShare = (event) => {
		var shareURL = typeof window !== 'undefined' ? window.location.href : ''
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Share - social icons',
			'formType': event + ' - ' + shareURL,
			'formId': 'Share',
			'formName': 'Share',
			'formLabel': 'Share'
		});
	}
	const currentpage = typeof window !== 'undefined' ? window.location.pathname : '';
	const ctaRender = (content, props)=>{
		if ( currentpage == '/holiday-homes/'){
			return <Link to={`/contact`} className="btn btn-primary">{'CONTACT US'}</Link>
		}if ( currentpage.includes('/mortgage-advice/')){
			return <a href={`https://dacha.useholo.com/en/mortgage-products-services`} target="_blank" className="btn btn-primary pre-app-cta">{'Get a Pre-approval'}</a>
		} else if(content.Static_Page_Sidebar_CTA_Label && props.popular_search == 'Popular_Search_Rent'){
			return <Link to={`/properties/for-rent/in-dubai`} className="btn btn-primary">{content.Static_Page_Sidebar_CTA_Label}</Link>
		}else if(content.Static_Page_Sidebar_CTA_Label){
			return <Link to={`/properties/for-sale/in-dubai`} className="btn btn-primary">{content.Static_Page_Sidebar_CTA_Label}</Link>
		} 
	}

	{/* Change Contact Number Only For /holiday-homes/ Page => https://starberry.monday.com/boards/436093956/pulses/2525410473 */}
	let title = "Are you looking for a property in Dubai?";
	let introText = "Get personalized advice from one of our property consultants today.";
	let contactnumber = props.site.Phone;
	
	if (currentpage === '/holiday-homes/') {
		contactnumber = "971505313003";
		title = "Are you looking to let your property short-term?";
		introText = "<p>Get in touch with our Holiday Homes team:</p>";
	} else {
		if (content?.Static_Page_Sidebar_Title) {
			title = content.Static_Page_Sidebar_Title;
		}
		if (content?.Static_Page_Sidebar_Content) {
			introText = content.Static_Page_Sidebar_Content;
		}
	}
    const number = contactnumber.replace(/ /g,'').replace(/\+/g,'');


	//console.log('static', props.popular_search)
	//console.log("shareurl",shareurl);

	var location_link = process.env.GATSBY_SITE_URL+location.pathname;

	var whatsapp_link = `https://wa.me/971586234140?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
	if(location.search.indexOf("utm_source") > 0){
		whatsapp_link = `https://wa.me/971586234140?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
	}

	const [modalContactformOpen, setContactformOpen] = React.useState(false);

	const openContactformModal = () => {
		setContactformOpen(true);
	}
	const closeContactformModal = () => {
		setContactformOpen(false);
	}

	return (

		<React.Fragment>
			<div className="left-sticky">
				<div className={`product-info static-page-sidebar ${props.class}`}>
				<h5 className="text-xl-bold">{title}</h5>
				<div className="text-sm sidebar-intro-content">
						{
							introText
								? HTMLReactParser(introText.replace(/<br\s*\/?>/gi, ''))
								: null
						}
				</div>

					<div className=" d-xl-flex row-btn-group product-info-btn-group">
						{ctaRender(content, props)}
						<a href={whatsapp_link} className="btn btn-outline btn-outline-dark btn-outline-whatsapp" target="_blank" >WhatsApp</a>
						{/* <Link href={`https://wa.me/${number}?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${shareurl}`} className="btn btn-outline btn-outline-dark btn-outline-whatsapp" target="_blank" >WhatsApp</Link> */}

					</div>
					{/*
						props.peoples && props.peoples.map((people, i) => {
							return (<div className="agent-info" key={i}>
								{people.Tile_Image &&
									<div className="agent-pic">
										<img src={people.Tile_Image.url} alt="" alt={`${people.Name} ${people.Designation} - Dacha`} />
									</div>
								}
								<div className="agent-info-details">
									<Link href={`/about-dacha/our-team/${people.URL}`}><strong className="agent-name">{people.Name}</strong></Link>
									<span className="agent-designation">{people.Designation}</span>
									{people.Phone &&
										<Link href={`tel:${people.Phone}`} className="agent-number"><i class="icon-people-phone"></i>{people.Phone}</Link>
									}
								</div>
							</div>)
						})
					*/}
					{(props.site.Email || number) &&
						<div className="agent-info">
						<div className="agent-pic default-logo">
							<img src={Dacha} alt="Dacha Logo" />
						</div>
						<div className="agent-data">
							<div className="default-contact-phone">
								<Link href={`tel:${props.site.Phone}`} className="text-sm">
									<span><PhoneIconGrey className="icon-contact-info" /></span>
									<span>{props.site.Phone}</span>
								</Link>
							</div>
							<div className="default-contact">
								<Link onClick={openContactformModal} className="text-sm contact-mail">
									<span><EnvelopeIconGrey className="icon-contact-info" /></span><span>Email</span>
								</Link>
								<Link href={whatsapp_link} className="text-sm" target="_blank">
									<span><WhatsAppIconGreen className="icon-contact-info" /></span><span>WhatsApp</span>
								</Link>
							</div>
						</div>
					</div>
					}
					{content?.Opening_Hours &&
						<div className="open-timing text-sm">
							{HTMLReactParser(content?.Opening_Hours.replace(/<br\s*\/?>/gi, ''))}
						</div>
					}
					{/*<div className="share-info">
						<a className="share-info-icon" href={"javascript:;"} onClick={openShareicons} onMouseLeave={closeShareicons}>
							<i className="icon-share"></i>
							<span>Share this Property</span>
							{Shareicons &&
								<div onMouseEnter={openShareicons} onMouseLeave={closeShareicons} className="property-share-social-icons">
									<FacebookShareButton onClick={() => trackerShare('FacebookShareButton')} url={shareurl} className="my-share-button facebook-share">
										<FacebookIcon size={32} round={false} borderRadius={`10`} />
									</FacebookShareButton>
									<TwitterShareButton onClick={() => trackerShare('TwitterShareButton')} url={shareurl} className="my-share-button twitter-share">
										<TwitterIcon size={32} round={false} borderRadius={`10`} />
									</TwitterShareButton>
									<LinkedinShareButton onClick={() => trackerShare('LinkedinShareButton')} url={shareurl} className="my-share-button linkedin-share">
										<LinkedinIcon size={32} round={false} borderRadius={`10`} />
									</LinkedinShareButton>
									<WhatsappShareButton onClick={() => trackerShare('WhatsappShareButton')} url={shareurl} className="my-share-button whatsapp-share">
										<WhatsappIcon size={32} round={false} borderRadius={`10`} />
									</WhatsappShareButton>
									<EmailShareButton url='#' onClick={() => { openSendfrndformModal(); trackerShare('SendToFriend') }} className="my-share-button email-share">
                  <EmailIcon size={32} round={false} borderRadius={`10`} />
            </EmailShareButton>

								</div>
							}
						</a>
						{props.brochure && props.brochure.length != 0 ?
							<a href={props.brochure[0].srcUrl} target="_blank" className="">
								<i className="icon-print"></i>
								<span>Print Brochure</span>
							</a>
							: ''}
					</div>*/}
				</div>
			</div>
			<ModalTiny show={modalContactformOpen} onHide={closeContactformModal} className="modal-form-wrapper">
                <ModalTiny.Header>
                <div class="modal-close-btn" onClick={closeContactformModal}><CloseIcon /></div>
                    <ModalTiny.Title>
						<h4>Contact</h4>
						<p className="text-sm">The Dacha team is always ready to help and answer any questions. Chat online with our friendly property experts or get in touch using the form below </p>
					</ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body>
                    <ContactForm />
                </ModalTiny.Body>
                </ModalTiny>
		</React.Fragment>
	)
}

export default Sidebar
